export const PAYMENT_HEADER_TITLE: { [key: string]: string } = {
    default: "Bill Total: {0}",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    post_order_tipping: "Tip: {0}",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    swiggy_money: "Select Payment",
    //Add other header key names based on values in Marketplace.ts
};

export const PAYMENT_HEADER_TITLE_V4: { [key: string]: string } = {
    default: "Payment Options",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    swiggy_money: "Select Payment",
    //Add other header key names based on values in Marketplace.ts
};

export const ADD_SWIGGYMONEY_SUBTITLE = "Add ₹{0} to Swiggy Money";
// TODO - remove below constant after feature is over
export const ADD_SWIGGYMONEY_GIFTING_SUBTITLE = "Total: ₹{0}";
export const SWIGGY_ONE_SUBTITLE = "Total: \u20B9{0}";

export const DISMISS = "Dismiss";
export const TRANSACTION_FAILED = "Transaction failed";
export const ITEM = "Item";
export const ITEMS = "Items";
export const TRY_OTHERS = "Try Others";
export const TRY_OTHER_PAYMENT_METHODS = "Try other Payment Methods";
export const OOPS_SOMETHING_WENT_WRONG = "Oops Something went wrong!!";
export const PAYMENT_ALERT_MAIN_TEXT = "Payment of ₹{0}";
export const PAYMENT_ALERT_SUB_TEXT = "For {0}";
export const BALANCE_X = "Balance: ₹{0}";
export const AVAILABLE_BALANCE_X = "Available balance: ₹{0}";
export const PAY_USING_X = "Pay Using {0}";
export const PAYMENT_WEBVIEW_TITLE = "Payments";
export const X_ITEM_DELIVERYING_Y_TO_PAY_Z = "{0} Item | Bill Amount: \u20B9{2} | Delivering to: {1}";
export const X_ITEMS_DELIVERYING_Y_TO_PAY_Z = "{0} Items | Bill Amount: \u20B9{2} | Delivering to: {1}";
export const TO_PAY_X = "To pay: \u20B9{0}";
export const X_ITEM_TOTAL_Y = "{0} item \u2022 Total: \u20B9{1}";
export const X_ITEMS_TOTAL_Y = "{0} items \u2022 Total: \u20B9{1}";
export const X_OFFER = " \u2022 {0}";
export const PAYMENT_METHODS_APPLICABLE = "Payment methods for this {0}";
export const NO_SAVED_CARDS = "No saved cards for this {0}";
export const DEFAULT_API_RETRY_DELAY_TIME_IN_MS = 100;
export const ICON_PAYMENT_FAILED_V4 = "PaymentLogos/paymentIcons/paylater/paymenterror";
export const HELP_TEXT = "Help";
export const GO_TO_HOME = "Go to Home";
export const TRACK_ORDER = "Track Order";
export const RETRY = "Retry";
export const LINK_LAZYPAY = "Link LazyPay";
export const TOING_QUICK_SAVING_TEXT = "SAVING {0} MINS WITH QUICK";
export const VERIFY_AND_PAY = "Verify and Pay";

export const PAYMENT_BACK_ALERT_OPTIONS = {
    message: "Are you sure you want to cancel",
    title: "Cancel Payment",
    buttonLabels: [
        {
            id: "1",
            text: "Yes",
            type: "primary",
        },
        {
            id: "2",
            text: "No",
            type: "secondary",
        },
    ],
};
export const X_WILL_BE_CHARGED = "\u20B9{0} will be charged";
export const SWIGGY_BANNER_CALLBACK_URL = "{0}&callback_url={1}";
export const NAVIGATION_ORDER_INTERRUPTION_SCREENS = {
    ORDER_DETAIL: "ORDER_DETAIL",
    DISMISS: "DISMISS",
    CART: "CART",
    IM_CART: "IM_CART",
};
export const ORDER_CONFIRM_LOADING_TEXT = "Hold On!";
export const ORDER_CONFIRM_LOADING_SUB_TEXT = "We are verifying your payment status.";

export const SUCCESS_TEXT = {
    DEFAULT: "Yay! Order Received",
    SUPER: "Yay! Plan Purchased",
    DEFAULT_SUB_TEXT: "Your order will be delivered shortly. Keep Swiggying!",
    CARD_SECURED: "Card was secured successfully!",
};

export const ORDER_HELP_PAGE_URL = "https://www.swiggy.com/support/issues/order?orderId={0}";
export const TOING_ORDER_HELP_PAGE_URL = "https://www.swiggy.com/support/issues/toing_order?orderId={0}";

export const RECORD_PAYMENT_LOAD_TIME = "blaze_checkout_web_payment_load_time";

export const PLAN_PURCHASE_PAGE = "Plan Purchase Page";
export const CART_PAGE = "Cart Page";
export const INAPP_UPI_BANNER_LINK = "inapp_upi";
export const ADD_NEW_CARD_PROMO_BANNER_LINK = "add-new-card-flow";
export const LP_PROMO_BANNER_LINK = "lazypay-payment-flow";
export const PPM_FOODCARD_PROMO_BANNER_LINK = "ppm-food-card-flow";
export const REGULAR_FOODCARD_PROMO_BANNER_LINK = "regular-food-card-flow";
export const PAYMENT_METHOD_DOWNTIME_BANNER_LINK = "pod-payment-method";
export const IM_NCM_BANNER_LINK = "emi-detail";
export const PAY_ON_DELIVERY_PREVIOUS_PAYMENT_SUCCESSFUL = "Your previous payment was received successfully!";
export const MWEB_UPI_APP_REDIRECT_FAILURE_MESSAGE = "{0} is not installed, please use a different option";

export const STATUS_BAR_DEFAULT_COLOR = "default";
